// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Content-module--cls1--29g5a","cls2":"styles-Content-module--cls2--16lRY styles-Content-module--cls1--29g5a"};